import { useMemo } from 'react';

import filter from '@Components/Grid/utils/filter';

export default function useFilters() {
  return useMemo(() => [
    filter
      .options.store('site_id', 'Site', 'sites')
      .multi(true),
    filter
      .options.list('dataType', 'Type', TYPE_OPTIONS)
      .multi(true),
    filter
      .options.list('status', 'Status', STATUS_OPTIONS)
      .setValue(options => options.includes("processing") ? options.concat("finishing") : options)
      .getValue(options => {
        if (!Array.isArray(options)) {
          return options
        }

        if (options.includes('processing')) {
          return options.filter(option => option !== 'finishing')
        }

        return options
      })
      .multi(true),
  ], [])
}

const TYPE_OPTIONS = [
  { label: "Subscriptions", value: "subscriptions" },
  { label: "User", value: "user" },
  { label: "Impression Drilldown", value: "impression-drilldown" },
  { label: "PubPerformance Drilldown", value: "losses-drilldown" },
  { label: "Surveys Drilldown", value: "surveys-drilldown" },
  { label: "Integration Drilldown", value: "integration-drilldown" },
  { label: "Site Verification Drilldown", value: "siteVerification-drilldown" },
]

const STATUS_OPTIONS = [
  { label: "Waiting", value: "waiting" },
  { label: "To Process", value: "to_process" },
  { label: "Processing", value: "processing" },
  { label: "Finished", value: "finished" },
  { label: "Error", value: "error" },
  { label: "Expired", value: "expired" },
  { label: "Canceled", value: "canceled" },
]
